var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58142 37L25.5 2.5L45.4186 37H5.58142ZM45.6351 37.375C45.6349 37.3747 45.6348 37.3744 45.6346 37.3741L45.6351 37.375ZM25.7161 2.12565L25.7165 2.125L25.5 2L25.7165 2.125C25.7164 2.12522 25.7163 2.12543 25.7161 2.12565Z",
    fill: "white",
    stroke: "#F44A5E",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8174 21.1953H26.6262V31.4303H24.8174V21.1953Z",
    fill: "#F44A5E",
    stroke: "#F44A5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8174 15.5781H26.6262V17.3869H24.8174V15.5781Z",
    fill: "#F44A5E",
    stroke: "#F44A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/dangerIcon.e16503a29163c04ba007c43d5df945b7.svg";
export { ForwardRef as ReactComponent };